import React from 'react'
import PropTypes from 'prop-types'

/**
 * MultiStepFlowFooter
 *
 * Footer component for multi-step flows with copyright and optional custom content.
 *
 * @param {Object} props
 * @param {string} props.copyrightText - Copyright text to display
 * @param {number} props.copyrightYear - Copyright year (defaults to current year)
 * @param {React.ReactNode} props.children - Additional footer content
 * @param {string} props.className - Additional CSS classes
 */
const MultiStepFlowFooter = ({
  copyrightText = 'Encircled. All rights reserved.',
  copyrightYear,
  children,
  className = ''
}) => {
  const year = copyrightYear || new Date().getFullYear()

  return (
    <footer className={`px-4 py-8 pb-12 border-t border-t-gray-300 ${className}`}>
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col items-center gap-2">
          {children && (
            <div className="mb-2">
              {children}
            </div>
          )}
          <p className="text-sm text-gray-600 text-center">
            &copy; {year} {copyrightText}
          </p>
        </div>
      </div>
    </footer>
  )
}

MultiStepFlowFooter.propTypes = {
  copyrightText: PropTypes.string,
  copyrightYear: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string
}

export default MultiStepFlowFooter